// extracted by mini-css-extract-plugin
export default {"container":"TimeOutInput_container__Z+Hg1","description":"TimeOutInput_description__Lcrlo","timeout":"TimeOutInput_timeout__1zHRP","header_lock":"TimeOutInput_header_lock__trXWy"};